import Box from "@mui/material/Box";
import List from "@mui/material/List";
import { styled } from "@mui/material/styles";
import CheckedListItem from "./CheckedListItem";

const isAtLeast8Chars = (str) => (str || "").length >= 8;

const hasLowerCase = (str) => /^(?=.*\p{Ll})/u.test(str || "");

const hasUpperChase = (str) => /^(?=.*\p{Lu})/u.test(str || "");

const hasNumber = (str) => /^(?=.*\p{Nd})/u.test(str || "");

const hasSymbol = (str) => /^(?=.*[?!@#$%^&*()[\]~_+-])/u.test(str || "");

export const isValidPassword = (password) =>
  isAtLeast8Chars(password) &&
  hasLowerCase(password) &&
  hasUpperChase(password) &&
  hasNumber(password) &&
  hasSymbol(password);

const PasswordChecker = (props) => {
  return (
    <Box className={props.className}>
      <List dense disablePadding>
        <CheckedListItem
          checked={props.password !== props.oldPassword}
          text="New password is different from old password"
        />
        <CheckedListItem
          checked={isAtLeast8Chars(props.password)}
          text="Is at least 8 characters long"
        />
        <CheckedListItem
          checked={hasLowerCase(props.password)}
          text="Has at least 1 lowercase letter"
        />
        <CheckedListItem
          checked={hasUpperChase(props.password)}
          text="Has at least 1 UPPERCASE letter"
        />
        <CheckedListItem
          checked={hasNumber(props.password)}
          text="Has at least 1 number"
        />
        <CheckedListItem
          checked={hasSymbol(props.password)}
          text={
            <span>
              Has at least 1 symbol:{" "}
              <span className="Symbols">? ! @ # $ % ^ & * ( ) [ ] ~ _ + -</span>
            </span>
          }
        />
        <CheckedListItem
          checked={
            isValidPassword(props.password) &&
            props.password === props.confirmPassword
          }
          text="Confirm password should match"
        />
      </List>
    </Box>
  );
};

export default styled(PasswordChecker)(
  ({ theme }) =>
    `
  min-width: 380px;

  .Symbols {
    padding: 6px;
    border-radius: 7px;
    border: 1px solid ${theme.palette.secondary.main};
    font-family: milliard-medium;
    font-weight: 700;
  }
`,
);
